import { Link } from 'react-router-dom';
import { Crown, Instagram, Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/zkwjbg2h_Royal%20Delights%20Logo.png";

export const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Chef Jaylon', path: '/about' },
    { name: 'The Experience', path: '/experience' },
    { name: 'Menu', path: '/menu' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' }
  ];

  const services = [
    'Plated Royal Dinner Party',
    'Royal Feast Buffet',
    'Private Chef Experiences',
    'Vegan Royalty Options',
    'Corporate Events',
    'Family Celebrations'
  ];

  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-[#27272A]">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={LOGO_URL} 
                alt="Royal Delights" 
                className="h-20 w-20 object-contain"
              />
            </Link>
            <p className="font-body text-[#A1A1AA] mb-6 leading-relaxed">
              Soulful luxury hibachi catering for every celebration. Experience the royal treatment.
            </p>
            <a 
              href="https://instagram.com/_royaldelights" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#F5F5F0] transition-colors font-body"
            >
              <Instagram className="w-5 h-5" />
              @_royaldelights
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg font-semibold text-[#F5F5F0] mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="font-body text-[#A1A1AA] hover:text-[#D4AF37] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading text-lg font-semibold text-[#F5F5F0] mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index} className="font-body text-[#A1A1AA]">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading text-lg font-semibold text-[#F5F5F0] mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span className="font-body text-[#A1A1AA]">Atlanta + surrounding region</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span className="font-body text-[#A1A1AA]">(404) 555-ROYAL</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span className="font-body text-[#A1A1AA]">info@royaldelights.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* CTA Banner */}
      <div className="border-t border-[#27272A] bg-[#121212]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <Crown className="w-8 h-8 text-[#D4AF37]" />
              <div>
                <h3 className="font-heading text-xl font-semibold text-[#F5F5F0]">Ready to Experience Royalty?</h3>
                <p className="font-body text-sm text-[#A1A1AA]">Book your soulful luxury hibachi experience today</p>
              </div>
            </div>
            <Link to="/booking">
              <button 
                data-testid="footer-book-btn"
                className="bg-[#D4AF37] text-black hover:bg-[#C5A028] font-semibold rounded-full px-8 py-4 text-sm transition-all duration-300 hover:scale-105 shadow-[0_0_20px_-8px_rgba(212,175,55,0.5)]"
              >
                Reserve Your Date
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-[#27272A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="font-body text-sm text-[#A1A1AA]">
              © {new Date().getFullYear()} Royal Delights. All rights reserved.
            </p>
            <p className="font-body text-sm text-[#A1A1AA]">
              Crafted with soul in Atlanta, GA
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
